/**
 * Mock User Data
 *
 * This file contains mock data for users.
 * In production, this would be replaced with API calls.
 */

export const mockUsers = [
  {
    id: 1,
    name: "John Doe",
    email: "john.doe@example.com",
    role: "User",
    status: "active",
    city: "New York",
    state: "NY",
    visibleMenus: ["leaderboards", "missions", "analytics"],
    createdAt: "2025-01-15",
    lastLogin: "2025-01-24",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane.smith@example.com",
    role: "Admin",
    status: "active",
    city: "Los Angeles",
    state: "CA",
    visibleMenus: [
      "analytics",
      "users",
      "payments",
      "entities",
      "leaderboards",
    ],
    createdAt: "2025-01-10",
    lastLogin: "2025-01-25",
  },
  {
    id: 3,
    name: "Mike Johnson",
    email: "mike.j@airport.com",
    role: "Airport",
    status: "active",
    city: "Chicago",
    state: "IL",
    visibleMenus: ["analytics", "missions", "airports-team"],
    createdAt: "2025-01-12",
    lastLogin: "2025-01-23",
  },
  {
    id: 4,
    name: "Sarah Williams",
    email: "sarah.w@nonprofit.org",
    role: "NonProfit",
    status: "active",
    city: "Houston",
    state: "TX",
    visibleMenus: ["analytics", "missions", "nonprofit-relations"],
    createdAt: "2025-01-18",
    lastLogin: "2025-01-24",
  },
  {
    id: 5,
    name: "David Brown",
    email: "david.b@pilot.com",
    role: "Pilot",
    status: "active",
    city: "Phoenix",
    state: "AZ",
    visibleMenus: ["missions", "leaderboards"],
    createdAt: "2025-01-20",
    lastLogin: "2025-01-25",
  },
  {
    id: 6,
    name: "Emily Davis",
    email: "emily.d@example.com",
    role: "User",
    status: "inactive",
    city: "Philadelphia",
    state: "PA",
    visibleMenus: ["leaderboards", "missions", "analytics"],
    createdAt: "2025-01-08",
    lastLogin: "2025-01-15",
  },
];

export const mockRoleChangeRequests = [
  {
    id: 1,
    userId: 1,
    userName: "John Doe",
    userEmail: "john.doe@example.com",
    currentRole: "User",
    requestedRole: "NonProfit",
    requestedAt: "2025-01-20",
    status: "pending",
    reason: "I want to manage a nonprofit organization",
  },
  {
    id: 2,
    userId: 6,
    userName: "Emily Davis",
    userEmail: "emily.d@example.com",
    currentRole: "User",
    requestedRole: "Airport",
    requestedAt: "2025-01-18",
    status: "pending",
    reason: "I work at an airport and want to coordinate missions",
  },
];

const mockData = {
  mockUsers,
  mockRoleChangeRequests,
};

export default mockData;
